import axios from "axios";
import _ from "lodash";
const api = process.env.VUE_APP_API_URL; // слеш в конце!

export default function(name) {
  // имя с большой буквы для camelCase в названиях
  const Name = name.charAt(0).toUpperCase() + name.substring(1);

  const Action = {
    FIND: "find" + Name,
    FINDONE: "findOne" + Name,
    CREATE: "create" + Name,
    UPDATE: "update" + Name,
    DELETE: "delete" + Name,
    MODEL: "loadModel" + Name
  };

  const Mutation = {
    LOAD: "load" + Name,
    LOADONE: "loadOne" + Name,
    LOADMODEL: "loadModel" + Name
  };

  const State = {
    LIMIT: "limit" + Name,
    SKIP: "skip" + Name,
    SORT: "sort" + Name,
    LIST: "list" + Name,
    ONE: "one" + Name,
    MODEL: "model" + Name,
    TOTAL: "total" + Name
  };

  return {
    state: {
      limit: 24,
      skip: 0,
      sort: null,
      list: [],
      one: {},
      model: {}
    },
    mutations: {
      [Mutation.LOAD]: (state, data) => {
        state.list = data;
      },
      [Mutation.LOADONE]: (state, data) => {
        state.one = data;
      },
      [Mutation.LOADMODEL]: (state, data) => {
        state.model = data;
      }
    },
    actions: {
      [Action.MODEL]: ({ commit }) => {
        return new Promise((resolve, reject) => {
          axios
            .get(api + "model/" + name)
            .then(resp => {
              commit(Mutation.LOADMODEL, resp.data);
              resolve(resp);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      [Action.FIND]: ({ commit, state }, params) => {
        params = Object.assign(
          {
            limit: state.limit,
            skip: state.skip,
            sort: state.sort
          },
          params
        );

        if (params.limit == -1) params = _.omit(params, "limit");

        return new Promise((resolve, reject) => {
          axios
            .get(api + name, { params })
            .then(resp => {
              commit(Mutation.LOAD, resp.data);
              resolve(resp);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      [Action.FINDONE]: ({ commit }, id) => {
        return new Promise((resolve, reject) => {
          axios
            .get(api + name + "/" + id)
            .then(resp => {
              commit(Mutation.LOADONE, resp.data);
              resolve(resp);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      [Action.CREATE]: ({ commit }, data) => {
        return new Promise((resolve, reject) => {
          axios
            .post(api + name, data)
            .then(resp => {
              commit(Mutation.LOADONE, resp.data);
              resolve(resp);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      [Action.UPDATE]: ({ commit }, opts) => {
        return new Promise((resolve, reject) => {
          axios
            .patch(api + name + "/" + opts.id, opts.data)
            .then(resp => {
              commit(Mutation.LOADONE, resp.data);
              resolve(resp);
            })
            .catch(err => {
              reject(err);
            });
        });
      },
      [Action.DELETE]: ({ commit }, id) => {
        return new Promise((resolve, reject) => {
          axios
            .delete(api + name + "/" + id)
            .then(resp => {
              commit(Mutation.LOADONE, {});
              resolve(resp);
            })
            .catch(err => {
              reject(err);
            });
        });
      }
    },
    getters: {
      [State.LIST]: ({ list }) => list,
      [State.ONE]: ({ one }) => one,
      [State.MODEL]: ({ model }) => _.omit(model, "totalItems"),
      [State.TOTAL]: ({ model }) => model.totalItems
    }
  };
}
